import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, catchError } from 'rxjs';
import { DataService } from '../data.service';
import { StateCountry, Organization } from 'src/app/shared/common-components/common-structure';
import { LoggerService } from '../../shared/common-components/logger.service';

@Injectable({
    providedIn: 'root'
})
export class DocuSignService extends DataService {

    private baseURI = this.apiUri + '/public/docusign/';
    private observable$: any;
    private _logger: LoggerService;

    constructor(http: HttpClient, logger: LoggerService) {
        super(http);
        this._logger = logger;
    }

    getAccessorialsCost(shipmentsId, payload): Observable<any> {
        return this.http.post(this.baseURI + shipmentsId + '/getAccessorialsCost/', payload);
      }
      
    getDocuSignEmbeddUrl(docMgrId : string): Observable<string> {
        return this.http.get(this.baseURI + 'getEmbeddedUrl/documentManagerId/'+docMgrId, {
            responseType: 'text'
        });
    }

    updateDocuSignStatusTSPSigned(docMgrId : string): Observable<string> {
        this.setUri(this.baseURI + 'updateDocuSignStatus/documentManagerId/'+docMgrId);
        return this.http.get(this.baseURI + 'updateDocuSignStatus/documentManagerId/'+docMgrId+'/tspOfficialSigned', {
            responseType: 'text'
        });
    }

    updateDocuSignStatusGSASigned(docMgrId : string): Observable<string> {
        this.setUri(this.baseURI + 'updateDocuSignStatus/documentManagerId/'+docMgrId);
        return this.http.get(this.baseURI + 'updateDocuSignStatus/documentManagerId/'+docMgrId+'/gsaOfficialSigned', {
            responseType: 'text'
        });
    }
}